import React from 'react';
import { Box, TextField, Alert, Typography, FormControlLabel, Switch } from '@mui/material';

import { UIConfigurationEditorProps } from '../types';

export const UIConfigurationEditor: React.FC<UIConfigurationEditorProps> = ({ ui, onChange }) => (
  <Box>
    <FormControlLabel
      control={
        <Switch
          checked={ui?.showSpinner || false}
          onChange={(e) => onChange({ ...ui, showSpinner: e.target.checked })}
        />
      }
      label="Show Spinner"
    />

    <TextField
      fullWidth
      value={ui?.startMessage || ''}
      onChange={(e) => onChange({ ...ui, startMessage: e.target.value })}
      label="Start Message"
      placeholder="Processing your request..."
      helperText="Message shown when the action starts"
      margin="normal"
    />

    <TextField
      fullWidth
      value={ui?.endMessage || ''}
      onChange={(e) => onChange({ ...ui, endMessage: e.target.value })}
      label="End Message"
      placeholder="Request completed successfully!"
      helperText="Message shown when the action completes"
      margin="normal"
    />

    <Alert severity="info" sx={{ mt: 2 }}>
      <Typography variant="body2">
        <strong>UI Behaviors:</strong>
        <br />• Start message shows immediately with streaming animation
        <br />• Spinner displays during processing
        <br />• End message shows after successful completion
        <br />• Error state shows retry button automatically
      </Typography>
    </Alert>
  </Box>
);
